import { isString, validateNotEmptyObject } from '@vy/utils';
import type React from 'react';
import { createElement } from 'react';
import type { ToastContent, Id as ToastId, ToastOptions } from 'react-toastify';
import { toast } from 'react-toastify';
import { DEFAULT_TOAST_OPTIONS } from './vy-toast-consts';
import type { SupportedToastMessages, ToastCallbacks } from './vy-toast-types';

export function userMessage(
  type: SupportedToastMessages,
  content: string,
  options?: Omit<ToastOptions, 'type'>,
): ToastCallbacks;
export function userMessage<MessageContentProps extends object>(
  type: SupportedToastMessages,
  content: React.FC<MessageContentProps>,
  props?: MessageContentProps,
  options?: Omit<ToastOptions, 'type'>,
): ToastCallbacks;
export function userMessage<MessageContentProps extends object>(
  type: SupportedToastMessages,
  content: string | React.FC<MessageContentProps>,
  props?: MessageContentProps,
  options?: Omit<ToastOptions, 'type'>,
): ToastCallbacks {
  const toastId = isString(content)
    ? showMessage(type, content, options)
    : showReactComponentMessage(type, content, props, options);

  return buildToastCallbacks(toastId);
}

function showReactComponentMessage<MessageContentProps extends object>(
  type: SupportedToastMessages,
  content: React.FC<MessageContentProps>,
  props?: MessageContentProps,
  options?: Omit<ToastOptions, 'type'>,
) {
  validateNotEmptyObject(props, 'props');

  const reactContent = createElement<MessageContentProps>(content, props);

  return showMessage(type, reactContent, options);
}

function showMessage(
  type: SupportedToastMessages,
  content: ToastContent,
  options?: Omit<ToastOptions, 'type'>,
) {
  const notify = toast[type];

  return notify(content, {
    ...DEFAULT_TOAST_OPTIONS,
    ...options,
  });
}

function buildToastCallbacks(toastId: ToastId): ToastCallbacks {
  return {
    dismiss: () => toast.dismiss(toastId),
  };
}
